import { GetStaticPaths, GetStaticProps } from 'next';
import React from 'react';

import Layout from '@/components/Layout';
import AlternateCapitalBlog from '@/containers/insights/AlternateCapitalBlog';
import AntlerBlog from '@/containers/insights/AntlerBlog';
import BessemerBlog from '@/containers/insights/BessemerBlog';
import BigLeapContext from '@/containers/insights/BigLeapContext';
import C4DPartnersBlog from '@/containers/insights/C4DPartnersBlog';
import FundFocusAugust from '@/containers/insights/FundFocusAugust';
import FundInFocusMersis from '@/containers/insights/FundFocusMersis';
import FundInFocus from '@/containers/insights/FundInFocus';
import FundInFocusAnicut from '@/containers/insights/FundInFocusAnicut';
import FundInFocusApril from '@/containers/insights/FundInFocusApril';
import FundInFocusArthaVenture from '@/containers/insights/FundInFocusArthaVenture';
import FundInFocusBain from '@/containers/insights/FundInFocusBain';
import FundInFocusDec from '@/containers/insights/FundInFocusDec';
import FundInFocusEmpoweringFintech from '@/containers/insights/FundInFocusEmpoweringFintech';
import FundInFocusFirstInvesting from '@/containers/insights/FundInFocusFirstInvesting';
import FundInFocusGrowthToSale from '@/containers/insights/FundInFocusGrowthToSale';
import FundInFocusIncred from '@/containers/insights/FundInFocusIncred';
import FundInFocusIndusHealth from '@/containers/insights/FundInFocusIndusHealth';
import FundInFocusIvycapVentures from '@/containers/insights/FundInFocusIvycapVentures';
import FundInFocusMarch2025 from '@/containers/insights/FundInFocusMarch2025';
import FundInFocusMay from '@/containers/insights/FundInFocusMay';
import FundInFocusOct from '@/containers/insights/FundInFocusOct';
import FundInFocusOct2 from '@/containers/insights/FundInFocusOct2';
import FundInFocusPandemicBlog from '@/containers/insights/FundInFocusPandemicBlog';
import FundInFocusPranaVentures from '@/containers/insights/FundInFocusPranaVentures';
import FundInFocusRockStudCapital from '@/containers/insights/FundInFocusRockStudCapital';
import FundInFocusSep from '@/containers/insights/FundInFocusSep';
import IndividualBlog from '@/containers/insights/IndividualBlog';
import MissingLinkBlog from '@/containers/insights/MissingLinkBlog';
import PrivateEquityPulse from '@/containers/insights/PrivateEquityPulse';
import PrudenceFunds from '@/containers/insights/PrudenceFunds';
import RiseInAiContextBlog from '@/containers/insights/RiseInAiContextBlog';
import TheAlternativeInvestmentContext from '@/containers/insights/TheAlternativeInvestmentContext';
import AugustContext from '@/containers/insights/TheAuguestContext';
import TheContextAIFDistributor from '@/containers/insights/TheContextAIFDistributor';
import TheContextAifsBlog from '@/containers/insights/TheContextAifsBlog';
import TheContextBalancingFounderBlog from '@/containers/insights/TheContextBalancingFounder';
import TheContextBudgetBlog from '@/containers/insights/TheContextBudgetBlog';
import TheContextCreditWhere from '@/containers/insights/TheContextCreditWhere';
import TheContextEconomyBlog from '@/containers/insights/TheContextEconomyBlog';
import TheContextEmpoweringIndia from '@/containers/insights/TheContextEmpoweringIndia';
import TheContextFamilyOfficesBlog from '@/containers/insights/TheContextFamilyOfficesBlog';
import TheContextFundBlog from '@/containers/insights/TheContextFundBlog';
import TheContextFundEcosystemBlog from '@/containers/insights/TheContextFundEcosystem';
import TheContextGlobalPowerHouse from '@/containers/insights/TheContextGlobalPowerHouse';
import TheContextGuidanceBlog from '@/containers/insights/TheContextGuidanceBlog';
import TheContextHousehold from '@/containers/insights/TheContextHousehold';
import TheContextIdeaForgeBlog from '@/containers/insights/TheContextIdeaForgeBlog';
import TheContextInvestBlog from '@/containers/insights/TheContextInvestBlog';
import TheContextInvestingBlog from '@/containers/insights/TheContextInvestingBlog';
import TheContextInvestorRightBlog from '@/containers/insights/TheContextInvestorsRightBlog';
import TheContextPaperAndPlastic from '@/containers/insights/TheContextPaperAndPlastic';
import TheContextPortfolioBlog from '@/containers/insights/TheContextPortfolioBlog';
import TheContextPotentialBlog from '@/containers/insights/TheContextPotentialBlog';
import TheContextPraxisBlog from '@/containers/insights/TheContextPraxisBlog';
import TheContextPrivateCredit from '@/containers/insights/TheContextPrivateCredit';
import TheContextSecondariesBlog from '@/containers/insights/TheContextSecondariesBlog';
import TheContextSeedBlog from '@/containers/insights/TheContextSeedBlog';
import TheContextStartupBlog from '@/containers/insights/TheContextStartupBlog';
import TheContextSustainableFinance from '@/containers/insights/TheContextSustainableFinance';
import ThePrivateEquityBlog from '@/containers/insights/ThePrivateEquityBlog';
import VC101Blog from '@/containers/insights/VC101Blog';
import VivritiCapitalContext from '@/containers/insights/VivritiCapitalContext';
import { Text } from '@chakra-ui/react';
import { Heading } from '@chakra-ui/react';

const AboutPerson: React.FC<{ slug: string }> = ({ slug }) => (
  <Layout>
    {slug.includes('0lu') ? (
      <BessemerBlog />
    ) : slug.includes('9w2') ? (
      <AntlerBlog />
    ) : slug.includes('the-context-df') ? (
      <TheContextSustainableFinance />
    ) : slug.includes('the-context-3t') ? (
      <TheContextGlobalPowerHouse />
    ) : slug.includes('the-context-bm') ? (
      <TheContextAIFDistributor />
    ) : slug.includes('thecontext-vh6') ? (
      <TheContextHousehold />
    ) : slug.includes('thecontext-8yz') ? (
      <TheContextPotentialBlog />
    ) : slug.includes('thecontext-iay') ? (
      <TheContextEconomyBlog />
    ) : slug.includes('thecontext-din') ? (
      <TheContextFundBlog />
    ) : slug.includes('thecontext-soi') ? (
      <TheContextInvestBlog />
    ) : slug.includes('thecontext-0kj') ? (
      <TheContextPortfolioBlog />
    ) : slug.includes('thecontext-lwx') ? (
      <TheContextIdeaForgeBlog />
    ) : slug.includes('thecontext-su0') ? (
      <TheContextSeedBlog />
    ) : slug.includes('thecontext-sst') ? (
      <TheContextGuidanceBlog />
    ) : slug.includes('thecontext-2my') ? (
      <MissingLinkBlog />
    ) : slug.includes('thecontext-vc101') ? (
      <VC101Blog />
    ) : slug.includes('thecontext-en4') ? (
      <TheContextPaperAndPlastic />
    ) : // ) : slug.includes('the-context') ? (
    //   <TheContextBlog />
    slug.includes('fund-in-focus-4rx') ? (
      <FundInFocusBain />
    ) : slug.includes('fund-in-focus-sl8') ? (
      <FundInFocusOct />
    ) : slug.includes('fund-in-focus-flz') ? (
      <FundInFocusOct2 />
    ) : slug.includes('fund-in-focus-incred') ? (
      <FundInFocusIncred />
    ) : slug.includes('fund-in-focus-7yi') ? (
      <FundInFocusAnicut />
    ) : slug.includes('fund-in-focus-14') ? (
      <FundInFocusIndusHealth />
    ) : slug.includes('xum') ? (
      <C4DPartnersBlog />
    ) : slug.includes('fund-in-focus-oc4') ? (
      <FundInFocusSep />
    ) : slug.includes('fund-in-focus-stride-ventures') ? (
      <FundInFocusDec />
    ) : slug.includes('kbz') ? (
      <FundInFocus />
    ) : slug.includes('tpb') ? (
      <FundInFocusApril />
    ) : slug.includes('fund-in-focus-7n') ? (
      <FundInFocusIvycapVentures />
    ) : slug.includes('t1c') ? (
      <FundInFocusMay />
    ) : slug.includes('private-equity-pulse-by-ivca') ? (
      <PrivateEquityPulse />
    ) : slug.includes('prudence-of-funds-the-need-of-the-hour') ? (
      <PrudenceFunds />
    ) : slug.includes('credit-where-credit-is-due') ? (
      <TheContextCreditWhere />
    ) : slug.includes('fund-in-focus-96') ? (
      <FundFocusAugust />
    ) : slug.includes('the-august-context') ? (
      <AugustContext />
    ) : slug.includes('vivriti-capital') ? (
      <VivritiCapitalContext />
    ) : slug.includes('fund-in-focus-mersis') ? (
      <FundInFocusMersis />
    ) : slug.includes('growth-to-sale') ? (
      <FundInFocusGrowthToSale />
    ) : slug.includes('the-sept-context') ? (
      <BigLeapContext />
    ) : slug.includes('the-context-alternative-investment') ? (
      <TheAlternativeInvestmentContext />
    ) : slug.includes('the-context-rise-in-ai-blog') ? (
      <RiseInAiContextBlog />
    ) : slug.includes('fund-in-focus-artha-venture') ? (
      <FundInFocusArthaVenture />
    ) : slug.includes('alternate-capital') ? (
      <AlternateCapitalBlog />
    ) : slug.includes('the-context-private-equity') ? (
      <ThePrivateEquityBlog />
    ) : slug.includes('the-context-empowering-india') ? (
      <TheContextEmpoweringIndia />
    ) : slug.includes('the-context-balancing-founder-incentives') ? (
      <TheContextBalancingFounderBlog />
    ) : slug.includes('from-pandemic-to-progress') ? (
      <FundInFocusPandemicBlog />
    ) : slug.includes('fund-in-focus-first-investing') ? (
      <FundInFocusFirstInvesting />
    ) : slug.includes('the-context-family-offices') ? (
      <TheContextFamilyOfficesBlog />
    ) : slug.includes('fund-in-focus-empowering-fintech') ? (
      <FundInFocusEmpoweringFintech />
    ) : slug.includes('the-context-startup-journey') ? (
      <TheContextStartupBlog />
    ) : slug.includes('the-context-budget-2025') ? (
      <TheContextBudgetBlog />
    ) : slug.includes('the-context-investors-right') ? (
      <TheContextInvestorRightBlog />
    ) : slug.includes('the-context-fund-ecosystem') ? (
      <TheContextFundEcosystemBlog />
    ) : slug.includes('the-context-private-credit') ? (
      <TheContextPrivateCredit />
    ) : slug.includes('the-context-aifs') ? (
      <TheContextAifsBlog />
    ) : slug.includes('the-context-praxis') ? (
      <TheContextPraxisBlog />
    ) : slug.includes('the-context-quantitative-investing') ? (
      <TheContextInvestingBlog />
    ) : slug.includes('the-context-quantitative-investing') ? (
      <TheContextInvestingBlog />
    ) : slug.includes('fund-in-focus-march-2025') ? (
      <FundInFocusMarch2025 />
    ) : slug.includes('fund-in-focus-rockstud-capital') ? (
      <FundInFocusRockStudCapital />
    ) : slug.includes('fund-in-focus-prana-ventures') ? (
      <FundInFocusPranaVentures />
    ) : slug.includes('the-context-secondaries-in-india') ? (
      <TheContextSecondariesBlog />
    ) : (
      <Heading>No blog found</Heading>
    )}
  </Layout>
);

export default AboutPerson;

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async (ctx) => {
  const slug = ctx.params?.slug;

  return {
    props: {
      slug,
    },
  };
};
